<template>
    <div class="main">
        <Menu purple :menu="menu">
            <template #title>
                <router-link to="/">
                    <img src="/logo2.png" style="height: 32px">
                </router-link>
            </template>
        </Menu>
        <router-view/>
    </div>
    <Footer/>
</template>

<script>
import {Menu, Footer} from 'eduair-shared'

export default {
    name: 'app',
    created(){
        document.title = "iTrain";
    },
    components:{
        Menu,
        Footer
    },
    data(){
        return {
            menu: [
                {id: 'Login', type: 'button', disable: true, image: require('./assets/login.png')},
                {type: 'line'},
                {id: 'EduAIR Official Website', type: 'link', href:'https://eduairsz.xyz', image: require('./assets/home.png')},
                {id: 'iPort ePlatform', type: 'link', href:'https://iport.eduairsz.xyz', image: require('./assets/website.png')},
            ]
        }
    }
}
</script>

<style>
.app{
    box-sizing: unset;
    border-radius: 0px;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    -ms-border-radius: 0px;
    -o-border-radius: 0px;
}

html, body{
    padding: 0;
    margin: 0;
    height: 100%;
    width: 100%;
    min-width: 320px;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
    html, body {
        min-width: 768px;
    }
}

@media (min-width: 1024px) {
    html, body {
        min-width: 1024px;
    }
}

@media (min-width: 1200px) {
    html, body {
        min-width: 1200px;
    }
}

body{
    background: #E8EAED; 
    --pin-0-color: #39499f;
    --pin-1-color: #f16465;
    --pin-2-color: #383838;
    --pin-3-color: #2db34a;
    --pin-4-color: #7c3218;
    --pin-5-color: #47c7ea;
}

div{
    padding: 0px 0px;
    position: relative;
    margin: 0;

    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */

    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}

*{
    font-family: 'Sans-Serif', Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.3px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -moz-font-smoothing: antialiased;
    font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-smooth: always;
    position: relative;
    z-index: 0;
}

@media (max-width: 480px) {
    * {
        font-size: 13px;
    }
}

.main{
    --background-color: #e8eaed;
    --color-primary: #e8f0fe;
    --color-primary-active: #D2E3FC;
    --color-secondary: #ffffff;
    --color-accent: #527DBF;
    --border-color: #79A9F7;
    --font-color-primary: #1967D2;
    --font-color-secondary: #000000;
    --font-color-accent: white;

    background-color: var(--background-color);
    border-radius: 0;
    min-height: 100%; 
    width: 100%; 
    height: 100vh;
    display: flex; 
    position: absolute; 
    justify-content: center;
    overflow-x: hidden;
}

@media (max-width: 768px) {
    .main {
        height: 100vh;
        min-height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}

@media (max-width: 480px) {
    .main {
        height: 100vh;
        min-height: 100vh;
        width: 100vw;
        max-width: 100vw;
    }
}

.unselectable{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

*{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}

/* Allow text selection in contenteditable and input elements */
[contenteditable="true"],
input,
textarea,
select {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

.undraggable{
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  pointer-events: none;
}

/* Mobile optimizations */
#app {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
}

@media (max-width: 480px) {
    #app {
        width: 100vw;
        max-width: 100vw;
        overflow-x: hidden;
    }
}

/* Ensure router-view fills screen on mobile */
@media (max-width: 480px) {
    .main > * {
        width: 100%;
        max-width: 100vw;
    }
}

/* iOS video autoplay fixes */
video {
    -webkit-playsinline: true;
    playsinline: true;
}

/* Ensure video elements can autoplay on iOS after user interaction */
video[autoplay] {
    -webkit-playsinline: true;
    playsinline: true;
}
</style>